// extracted by mini-css-extract-plugin
module.exports = {"notice":"AlertNotice_notice__3-8is","noticeIcon":"AlertNotice_noticeIcon__1AHol","noticeTitle":"AlertNotice_noticeTitle__8xh7Z","noticeBody":"AlertNotice_noticeBody__14lxD"};